import { acceptHMRUpdate, defineStore } from 'pinia'
import find from 'lodash/find'
import compact from 'lodash/compact'
import { calculatePricing } from '@/transforms/text'

export const useFavorites = defineStore('favorites', {
  state: () => ({
    currentConfig: {} as ConfigurationType,
    isSynced: false,
  }),
  getters: {
    selectedModel(state): ModelNameType | AnyObject {
      return state.currentConfig.model ?? {}
    },
    selectedFrame(state): FrameColorType | AnyObject {
      return state.currentConfig.frame ?? {}
    },
    selectedTemple(state): TempleColorType | AnyObject {
      return state.currentConfig.temple ?? {}
    },
    selectedLen(state): LensColorType | AnyObject {
      return state.currentConfig.len ?? {}
    },
    selectedLogo(state): LogoType {
      return {
        logoBackColor: state.currentConfig?.logoBackColor ?? '',
        logoFrontColor: state.currentConfig?.logoFrontColor ?? '',
      }
    },
    selectedLenOption(state): string[] {
      if (state.currentConfig?.lensOptions?.length)
        return state.currentConfig.lensOptions
      return ['none']
    },
    selectedBridgeName(state): string {
      return state.currentConfig.bridge?.value ?? ''
    },
    variantPrice: state => calculatePricing(state.currentConfig),
    variantName: state => state.currentConfig?.model?.description ?? '',
    addToCartVariant(state: AnyObject) {
      const logoEnabled = state.currentConfig?.model?.logoEnabled
      const isEnabledLogoFront = logoEnabled === 'both' || logoEnabled === 'front'
      const isEnabledLogoBack = logoEnabled === 'both' || logoEnabled === 'back'

      const logoFrontColorValue = isEnabledLogoFront ? (state.currentConfig?.logoFrontColor ?? '') : ''
      const logoFrontColorData = find(state.currentConfig.logoFrontInfo, { value: logoFrontColorValue })
      const logoBackColorValue = isEnabledLogoBack ? (state.currentConfig?.logoBackColor ?? '') : ''
      const logoBackColorData = find(state.currentConfig.logoBackInfo, { value: logoBackColorValue })
      const lensOptions = state.selectedLenOption
      const lensOptionsText = compact(lensOptions.map(key => find(state.currentConfig.lensOptionsInfo, { value: key }))).map(item => item.name)
      return {
        glassesVariant: {
          modelName: state.currentConfig?.model?.value ?? '',
          modelNameText: state.currentConfig?.model?.name ?? '',
          frameColor: state.currentConfig?.frame?.value ?? '',
          frameColorText: state.currentConfig?.frame?.name ?? '',
          templeColor: state.currentConfig?.temple?.value ?? '',
          templeColorText: state.currentConfig?.temple?.name ?? '',
          lensColor: state.currentConfig?.len?.value ?? '',
          lensColorText: state.currentConfig?.len?.name ?? '',
          logoFrontColor: logoFrontColorValue,
          logoFrontColorText: logoFrontColorData?.name ?? '',
          logoBackColor: logoBackColorValue,
          logoBackColorText: logoBackColorData?.name ?? '',
          lensOptions,
          lensOptionsText,
          bridgeName: state.currentConfig?.bridge?.value ?? '',
          bridgeNameText: state.currentConfig?.bridge?.name ?? '',
          thumbnailUrl: state.currentConfig?.thumbnailUrl ?? '',
        },
        price: calculatePricing(state.currentConfig),
      }
    },
  },
  actions: {
    setCurrentConfig(key = '', value) {
      key && (this.currentConfig[key] = value)
    },
    setInitial(defaultConfig: ConfigurationType) {
      Object.assign(this.currentConfig, defaultConfig)
    },
    setActiveSynced(value: boolean) {
      this.isSynced = value
    },
    resetDefault() {
      return new Promise((resolve) => {
        Object.assign(this.currentConfig, {})
        resolve(true)
      })
    },
  },
  share: {
    enable: false,
    initialize: false,
  },
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useFavorites, import.meta.hot))
